/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { PropTypes, Component } from 'react';
import { NitroIcon } from 'nitro-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  Background,
  Dialog,
  DialogContainer,
  GlobalSearchMobileDropDown,
  GlobalSearchMobileInput
} from './css';

import {
  HeaderIcon,
  MobileHeader
} from '../../../components/common/Menu/Sidebar/styles';

import { GlobalSearchTypeDropdown } from './GlobalSearchTypeDropdown';
import { SEARCH_RESULT } from '../../../routes/const';

import {
  isFetchingHistory,
  getHistory,
  getInputText,
  onInput,
  getSeletedType,
  onSelect,
  fetchSearchBarHistory,
  setShowHistory,
  getShowHistory,
  isFetchingCategoryHistory,
  getCategoryHistory,
  fetchSearchBarCategoryHistory
} from './store/action';
import { SEARCH_TYPE_MAP } from './store/TYPES';

class GlobalSearchMobile extends Component {
  componentDidMount() {
    if (this.props.isOpen) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentWillUpdate(nextProps) {
    if (nextProps.isOpen !== this.props.isOpen) {
      if (nextProps.isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = 'auto';
  }

  render() {
    const {
      isOpen,
      categoryHistory,
      history,
      isFetchingCategoryHistory,
      isFetchingHistory,
      inputText,
      input,
      showHistory,
      setShowHistory,
      selected,
      select,
      close,
      // actions
      fetchSearchBarCategoryHistory,
      fetchSearchBarHistory
    } = this.props;

    const globalSearch = () => {
      if (inputText !== '') {
        const { router } = this.context;
        input({ inputText, fetch: true });
        router.push(SEARCH_RESULT);
        close();
      }
    };
    const closeHistory = () => {
      setTimeout(() => {
        setShowHistory(false);
      }, 750);
    };

    const handleBodyClick = (event, { searchTerm, type }) => {
      event.stopPropagation();
      select({ label: type, value: type });
      input({ inputText: searchTerm, fetch: true });
      if (window.location.pathname !== SEARCH_RESULT) {
        this.context.router.push(SEARCH_RESULT);
      }
      setTimeout(() => {
        onInput({ inputText: searchTerm, fetch: true });
        setShowHistory(false);
        close();
      }, 250);
    };
    const fetchHistory = () => {
      if (!isFetchingHistory) {
        fetchSearchBarHistory({
          offset: 0,
          limit: 10,
          lookup: '',
          sort: null
        });
      }
    };

    const getCategoryHistory = () => {
      if (!isFetchingCategoryHistory) {
        fetchSearchBarCategoryHistory({
          offset: 0,
          limit: 5,
          lookup: '',
          sort: null,
          historyCategory: SEARCH_TYPE_MAP[selected]
        });
      }
    };

    const filteredHistory = history
      .filter(({ HistoryCategory }) => HistoryCategory !== selected)
      .slice(0, 5);

    return (
      <Dialog open={isOpen}>
        <Background open={isOpen} />
        <DialogContainer open={isOpen}>
          <MobileHeader>
            <span>SEARCH</span>
            <HeaderIcon name="close" size={15} variant="white" action={close} />
          </MobileHeader>
          <GlobalSearchMobileDropDown>
            <GlobalSearchTypeDropdown selected={selected} onSelect={select} />
          </GlobalSearchMobileDropDown>
          <GlobalSearchMobileInput>
            <input
              placeholder="Search"
              value={inputText}
              onFocus={() => {
                setShowHistory(true);
                getCategoryHistory();
                fetchHistory();
              }}
              onChange={e => {
                input(e.target.value);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter' && inputText) {
                  closeHistory();
                  globalSearch();
                }
              }}
              onBlur={closeHistory}
            />
            {showHistory && !isFetchingHistory && !isFetchingCategoryHistory && (
              <ul>
                {categoryHistory && <p>RECENT {selected} SEARCHES</p>}
                {categoryHistory &&
                  categoryHistory.map(item => (
                    // eslint-disable-neitemt-line jsx-a11y/no-noninteractive-element-interactions
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                    <li
                      key={item.Id}
                      onClick={e =>
                        handleBodyClick(e, {
                          searchTerm: item.SearchTerm,
                          type: item.HistoryCategory
                        })
                      }>
                      <NitroIcon name="recent" variant="base2" size="16" />
                      {item.SearchTerm}
                    </li>
                  ))}
                {history && <p>RECENT SEARCHES</p>}
                {history &&
                  filteredHistory.map(item => (
                    // eslint-disable-neitemt-line jsx-a11y/no-noninteractive-element-interactions
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                    <li
                      key={item.Id}
                      onClick={e =>
                        handleBodyClick(e, {
                          searchTerm: item.SearchTerm,
                          type: item.HistoryCategory
                        })
                      }>
                      <NitroIcon name="recent" variant="base2" size="16" />
                      {item.SearchTerm}
                    </li>
                  ))}
              </ul>
            )}
            {inputText !== '' && !showHistory ? (
              <NitroIcon
                name="close"
                variant="brownGrey"
                action={() => input('')}
              />
            ) : (
              <NitroIcon name="search" action={globalSearch} />
            )}
          </GlobalSearchMobileInput>
        </DialogContainer>
      </Dialog>
    );
  }
}

GlobalSearchMobile.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  isFetchingHistory: PropTypes.bool,
  history: PropTypes.arrayOf(PropTypes.shape({})),
  fetchSearchBarHistory: PropTypes.func
};

GlobalSearchMobile.defaultProps = {
  isFetchingHistory: false,
  isOpen: false,
  close: () => {},
  fetchSearchBarHistory: () => {},
  history: []
};

GlobalSearchMobile.contextTypes = {
  router: PropTypes.shape({})
};

const mapStateToProps = state => ({
  isFetchingHistory: isFetchingHistory(state),
  isFetchingCategoryHistory: isFetchingCategoryHistory(state),
  history: getHistory(state),
  categoryHistory: getCategoryHistory(state),
  inputText: getInputText(state),
  selected: getSeletedType(state),
  showHistory: getShowHistory(state)
});

const mapDispatchToProps = dispatch => ({
  fetchSearchBarHistory: bindActionCreators(fetchSearchBarHistory, dispatch),
  fetchSearchBarCategoryHistory: bindActionCreators(
    fetchSearchBarCategoryHistory,
    dispatch
  ),
  input: bindActionCreators(onInput, dispatch),
  select: bindActionCreators(onSelect, dispatch),
  setShowHistory: bindActionCreators(setShowHistory, dispatch)
});

// export default GlobalSearchMobile;
export default connect(mapStateToProps, mapDispatchToProps)(GlobalSearchMobile);



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/GlobalSearchMobile.js